export default __webpack_public_path__ + "static/media/oldsteel.b5a52cf7.jpeg";